module.exports = __webpack_public_path__ + "static/media/matrix_bg.0506e492.jpg";